import styled from 'styled-components';
import { Modal } from '@hud/web-components/Modal/Modal';
import {
  textMediumSemiBold,
  textMediumNormal,
} from '@hud/web-components/DesignSystem/Typography';

export const StyledConfirmDisconnectDialog = styled(Modal)`
  padding: var(--space-0);
  max-width: 500px;
  background: var(--black-200);
  border-radius: var(--border-radius-button);

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--space-150) var(--space-200);
    border-bottom: 1px solid var(--border-color-default);
  }

  .modal-title {
    ${textMediumSemiBold};
    color: var(--text-standard-primary);
    margin: var(--space-0);
  }

  .close-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: var(--space-25);
    color: var(--text-standard-secondary);
    border-radius: var(--border-radius-button);
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: var(--black-300);
    }
  }

  .modal-content {
    padding: var(--space-200);
  }

  .modal-description {
    ${textMediumNormal};
    color: var(--text-standard-primary);
    margin: 0;
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: var(--space-200);
    padding: var(--space-150) var(--space-200);
  }

  .text-button {
    ${textMediumNormal};
    background: none;
    border: none;
    cursor: pointer;
    color: var(--text-standard-primary);
    padding: var(--space-100);
    border-radius: var(--border-radius-button);

    &:hover {
      text-decoration: underline;
    }
  }
`;
